module.exports = __webpack_public_path__ + "img/actbanner.9b9bdb40.png";